import {Box} from "@mui/material";
import {BaseTextarea} from "../../designSystem/components/BaseTextarea";
import React from "react";

export const LongAnswer = ({
   label, value, onChange,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
    >
      <Box className="page-title text-xl">
        {label}
      </Box>
      <BaseTextarea
        isDisabled={false}
        onChange={onChange}
        value={value}
        isRequired={false}
      />
    </Box>
  )
}
